import { render, staticRenderFns } from "./recommendation.vue?vue&type=template&id=188e4d9b&"
import script from "./recommendation.vue?vue&type=script&lang=js&"
export * from "./recommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports